import React, { Component } from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import RadioButtonGroup1 from "../../RadioButtonGroup/RadioButtonGroupLayer/RadioButtonGroup1";
import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";
import InitialQuotationState from "../../InitialQuotationState";

let layers = [
    {id: 1, checked: false, text:  <FormattedMessage id="app.pcb-quotation.pcb-layers-1"
                                                     defaultMessage="Layers"
                                                     description=""/>, name: "layer", disabled:false},
    {id: 2, checked: true, text:  <FormattedMessage id="app.pcb-quotation.pcb-layers-2"
                                                    defaultMessage="Layers"
                                                    description=""/>, name: "layer",  disabled:false},
    {id: 4, checked: false, text:  <FormattedMessage id="app.pcb-quotation.pcb-layers-4"
                                                     defaultMessage="Layers"
                                                     description=""/>, name: "layer",  disabled:false},
    // {id: 6, checked: false, text:  <FormattedMessage id="app.pcb-quotation.pcb-layers-6"
    //                                                  defaultMessage="Layers"
    //                                                  description=""/>, name: "layer",  disabled:false},
];

class Layers extends Component {

    constructor(props){
        super(props);
        this.state = {
            layers : layers
        }
        this.topicChange=this.topicChange.bind(this)
    }
    //
    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if(prevProps !== this.props){
    //         layers = layers.map((item) => {
    //             if(item.id === this.props.pcbParams.layer){
    //                 item.checked = true
    //             }else{
    //                 item.checked = false
    //             }
    //
    //             return item;
    //         });
    //
    //
    //
    //         // layers = pcbLayers
    //     }
    // }

    topicChange=()=>{
        InitialQuotationState.currentTopic="layer"

    }


    render() {
        let pcbLayers = layers.map((item) => {
            if(item.id === this.props.pcbParams.layer){
                item.checked = true
            }else{
                item.checked = false
            }
            return item;
        });

        // console.log("PCB PARAMS DUO LAYERS ++++++++++++++++++++++++++++++> ", this.props.pcbParams.layer);
        // console.log("LAYERS ARRAY UPDATED DUO =========================> ", pcbLayers);
        return (
            <div className="row">
                <div className="col-md-12 no-padding">
                    <div className="pcb-details-div">
                        <div className="col-md-3 text-right content-item-heading">
                            <FormattedMessage id="app.pcb-quotation.pcb-layers"
                                              defaultMessage="Layers"
                                              description=""
                            />
                            &nbsp; &nbsp;
                            {/*<Link id="layers-qLink" to="/help/layerHelp"*/}
                                  {/*className="glyphicon glyphicon-question-sign question-link">*/}
                            {/*</Link>*/}
                            <Link id="pcbImpd-qLink" className="glyphicon glyphicon-question-sign question-link"
                                  onClick={this.topicChange}
                                  to={{pathname:"https://kitcutlabo.com/pcb-layers/",
                                  thickness: 1
                                  }} target="_self"
                            />
                        </div>

                        <div className="col-md-9 pcb-details-div-items">
                            {
                                this.props.pcbParams.layer === 2 ?

                                    <RadioButtonGroup1 data={layers} getParams={this.props.setPCBParams}/>
                                    :
                                    ""
                            }
                            {
                                this.props.pcbParams.layer !== 2 ?

                                    <RadioButtonGroup1 data={pcbLayers} getParams={this.props.setPCBParams}/>
                                    :
                                    ""
                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    };

}

export default Layers;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/Layers.js